import styled from 'styled-components/macro';
import { defaultContainer } from '../styles/utils';
import { OutlineButton, PrimaryButton } from './ButtonStyles';
import { textLinkBase } from './LinkStyles';

export const ReferralLinkDiv = styled.div`
  h5 {
    margin-bottom: 10px;
  }
  @media screen and (min-width: 1440px) {
    align-items: center;
    h5 {
      margin-right: 10px;
    }
  }
  && {
    @media screen and (max-width: 767px) {
      ${PrimaryButton} {
        padding: 1rem;
        font-weight: 600;
        max-width: 180px;
      }
    }
  }
`;

export const ReferralOptionsBackgroundDiv = styled.div`
  background-color: ${props => props.theme.concrete};
`;

export const ReferralOptionsDiv = styled.div`
  ${defaultContainer}
  padding-top: 9rem;
  padding-bottom: 9rem;
  > h4 {
    margin-bottom: 1rem;
  }
  @media screen and (min-width: 768px) {
    padding: 9rem 3rem;
  }
  @media screen and (min-width: 1024px) {
    padding: 9rem 3rem;
  }
  @media screen and (min-width: 1440px) {
    padding: 9rem 8rem;
  }
`;

export const ReferralOptionDiv = styled.div`
  background-color: white;
  ${props => props.theme.defaultDropShadow}
  padding: 4rem 3rem;
  p {
    margin: 1rem 0 1.5rem;
  }
  h4 svg {
    margin-right: 5px;
    transform: translateY(2px);
  }
  & + & {
    margin-top: 1.5rem;
  }
  @media screen and (min-width: 768px) {
    padding: 4rem 2.5rem;
    & + & {
      margin-top: 0;
      margin-left: 1.5rem;
    }
  }
  @media screen and (min-width: 1440px) {
    padding: 4rem;
  }
`;

export const ReferralOptionsContainerDiv = styled.div`
  display: flex;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ReferralOptionCopyDiv = styled.div`
  ${PrimaryButton} {
    margin-top: 1.5rem;
    padding: 1.5rem;
  }
  @media screen and (min-width: 768px) {
    display: flex;
  }
  margin-top: 12px;
`;

export const ReferralUrlA = styled.a`
  ${textLinkBase}
  @media screen and (min-width: 768px) {
    white-space: nowrap;
  }
  text-decoration: none;
  vertical-align: center;
  @media screen and (min-width: 768px) {
    border-bottom: 1px solid ${props => props.theme.blue};
  }
  @media screen and (max-width: 767px) {
    line-height: 1.59;
    display: inline-block;
    /* max-width: 80%; */
  }
`;

export const CopyButtonA = styled(OutlineButton)`
  @media screen and (max-width: 767px) {
    margin-top: 1.5rem;
    padding: 1.5rem;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    border: none;
  }
  @media screen and (min-width: 768px) {
    margin-left: 1rem;
    padding: 0.5rem;
    transform: translateY(-1px);
    width: auto;
  }

  @media screen and (min-width: 1440px) {
    padding: 0.5rem 1.5rem;
  }
`;
